import React from "react";
import CategoryChild from "./CategoryChild";
import ReUse from "../../services/helpers/reUse";

const CatsSubcats = (propsData) => {
  const { id, name, slug, icon, icon_path, childes } = propsData;

  console.log(id ,"iconid")

  const test = 1;

  return (
    <>
      <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingtwo">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#flush-collapse${id}`}
            aria-expanded="false"
            aria-controls="flush-collapsetwo"
          >
            {/* {name && name} */}
            {name}
          </button>
        </h2>
        <div
          id={`flush-collapse${id}`}
          class="accordion-collapse collapse"
          aria-labelledby="flush-headingtwo"
          data-bs-parent="#accordionFlushExample"
        >
          <div class="accordion-body">
            <ul className="accessories-body">
              {ReUse.mapItems(false, childes, CategoryChild)}
              {/* <CategoryChild /> */}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default CatsSubcats;
